import { Template } from "../template/Template.js";
import { ADOBE_INVOICE } from "./invoice/AdobeInvoice.js";
import { APPLE_LIGHTROOM_INVOICE } from "./invoice/AppleLightroomInvoice.js";
import { HETZNER_INVOICE } from "./invoice/HetznerInvoice.js";
import { INCOMING_EU_INVOICE } from "./invoice/IncomingEuInvoice.js";
import { INCOMING_NO_VAT_INVOICE } from "./invoice/IncomingNoVatInvoice.js";
import { INCOMING_VAT_INVOICE } from "./invoice/IncomingVatInvoice.js";
import { PHONE_INVOICE } from "./invoice/PhoneInvoice.js";
import { BANK_CARD_FEE } from "./misc/BankCardFee.js";
import { CASH } from "./misc/Cash.js";
import { DIVIDENDS } from "./misc/Dividends.js";
import { HEALTH_SUPPORT } from "./misc/HealthSupport.js";
import { HOME_OFFICE_RENOVATION } from "./misc/HomeOfficeRenovation.js";
import { HOME_OFFICE_UTILITIES } from "./misc/HomeOfficeUtilities.js";
import { RAIVO_SALARY } from "./misc/RaivoSalary.js";
import { OUTGOING_EU_INVOICE } from "./sales/OutgoingEuInvoice.js";
import { OUTGOING_VAT_INVOICE } from "./sales/OutgoingVatInvoice.js";
import { TAX_DEBT_PAYMENT } from "./taxes/TaxDeptPayment.js";
import { TAXES } from "./taxes/Taxes.js";
import { VAT_CREDIT } from "./taxes/VatCredit.js";
import { VAT_DEBT } from "./taxes/VatDebt.js";

/**
 * List of templates available to the system.
 */
export const TEMPLATES: Template[] = [
  INCOMING_VAT_INVOICE,
  INCOMING_NO_VAT_INVOICE,
  INCOMING_EU_INVOICE,
  OUTGOING_EU_INVOICE,
  OUTGOING_VAT_INVOICE,
  APPLE_LIGHTROOM_INVOICE,
  PHONE_INVOICE,
  HETZNER_INVOICE,
  ADOBE_INVOICE,
  TAXES,
  VAT_DEBT,
  VAT_CREDIT,
  TAX_DEBT_PAYMENT,
  BANK_CARD_FEE,
  CASH,
  DIVIDENDS,
  HEALTH_SUPPORT,
  HOME_OFFICE_RENOVATION,
  HOME_OFFICE_UTILITIES,
  RAIVO_SALARY
];

/**
 * Ensures that all templates have unique IDs.
 */
const checkUniqueIds = () => {
  const ids = new Set<string>();
  for (const template of TEMPLATES) {
    if (ids.has(template.id)) {
      throw new Error(`Duplicate template ID: ${template.id}.`);
    }
    ids.add(template.id);
  }
};

checkUniqueIds();
